import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { UserRole } from '../types/api.types';

export const RoleRoute = ({ allowedRoles }: { allowedRoles: UserRole[] }) => {
  const { role, isLoading } = useAuth();
  if (isLoading) return <div className="p-8">Loading...</div>;
  if (!role || !allowedRoles.includes(role)) return <Navigate to="/" replace />;
  return <Outlet />;
};
